import { useEffect, useState, useCallback } from 'react';
import { UserCheck, ChevronDown, ChevronRight } from 'lucide-react';
import { apiGet } from '../lib/api';
import { FollowUpList, type FollowUpTask } from './FollowUpList';

interface MeetingFollowUpsProps {
  instanceId: string;
  meetingName?: string;
  refreshTrigger: number;
}

export function MeetingFollowUps({ instanceId, meetingName, refreshTrigger }: MeetingFollowUpsProps) {
  const [followUps, setFollowUps] = useState<FollowUpTask[]>([]);
  const [isOpen, setIsOpen] = useState(true);
  const [refreshCount, setRefreshCount] = useState(0);

  const load = useCallback(async () => {
    try {
      const data = await apiGet<FollowUpTask[]>(`/meeting-instances/${instanceId}/follow-ups`);
      setFollowUps(data);
    } catch (err) {
      console.error('Failed to load follow-ups:', err);
    }
  }, [instanceId]);

  useEffect(() => { load(); }, [load, refreshTrigger, refreshCount]);

  return (
    <div className="px-3 py-2">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 w-full text-left py-1.5 text-xs font-semibold text-text-secondary uppercase tracking-wide hover:text-text-primary transition-colors"
      >
        {isOpen ? <ChevronDown size={12} /> : <ChevronRight size={12} />}
        <UserCheck size={14} />
        <span className="flex-1">Follow-ups</span>
        {followUps.length > 0 && (
          <span className="text-[10px] font-normal text-text-muted bg-bg-hover rounded-full px-1.5 py-0.5">
            {followUps.length}
          </span>
        )}
      </button>
      {isOpen && (
        <div className="mt-2">
          <FollowUpList
            followUps={followUps}
            onStatusToggle={() => setRefreshCount(c => c + 1)}
            meetingName={meetingName}
            instanceId={instanceId}
          />
        </div>
      )}
    </div>
  );
}
